// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__XrcUS","clear":"FiltersBlock_clear__jwEjN","filters_close":"FiltersBlock_filters_close__MITLU"};